import { createAuth0, Auth0VueClient, AUTH0_INJECTION_KEY } from '@auth0/auth0-vue';
import { ref, App } from 'vue';

declare const DEV_BYPASS_AUTH: string | undefined;
declare const AUTH0_DOMAIN: string;
declare const AUTH0_CLIENTID: string;

const isDevBypass = typeof DEV_BYPASS_AUTH !== 'undefined' && DEV_BYPASS_AUTH === 'true';

let auth0: Auth0VueClient;

if (isDevBypass) {
        // Create mock Auth0 client for development bypass mode
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        const mockAuth0: any = {
                isAuthenticated: ref(true),
                isLoading: ref(false),
                user: ref({
                        name: 'Dev User',
                        email: 'dev@localhost',
                        sub: 'dev|123',
                        app_metadata: {
                                modules: [
                                        '2D Models', '3D Models', 'API permission', 'App Setting',
                                        'Badges', 'Bulk Discount', 'Category', 'Countries', 'Cross Sell',
                                        'Currencies', 'Discount', 'Discount Voucher', 'Flex Group',
                                        'Hyperlinks', 'Layouts', 'Lister Items', 'Offering', 'Offering Option',
                                        'Page Background', 'PDPs', 'Photoframes', 'Pricing', 'Products Ordered',
                                        'Regions', 'Shipping', 'Stickers', 'Templates', 'Themes',
                                ],
                        },
                }),
                idTokenClaims: ref(undefined),
                error: ref(undefined),
                loginWithRedirect: async () => {},
                loginWithPopup: async () => {},
                logout: async () => {},
                getAccessTokenSilently: async () => '',
                getAccessTokenWithPopup: async () => '',
                checkSession: async () => {},
                handleRedirectCallback: async () => ({ appState: undefined }),
                getDpopNonce: async () => undefined,
                setDpopNonce: async () => {},
                generateDpopProof: async () => '',
                createFetcher: () => fetch,
        };
        
        const mockPlugin = {
                ...mockAuth0,
                install(app: App) {
                        app.config.globalProperties.$auth0 = mockAuth0;
                        app.provide(AUTH0_INJECTION_KEY as symbol, mockAuth0);
                },
        };
        // Dev bypass mode
        auth0 = mockPlugin as Auth0VueClient;
} else {
        auth0 = createAuth0({
                domain: AUTH0_DOMAIN,
                clientId: AUTH0_CLIENTID,
                authorizationParams: {
                        redirect_uri: window.location.origin,
                },
                cacheLocation: 'localstorage',
                useRefreshTokens: true,
        });
}

export default auth0;
